module.exports = __webpack_public_path__ + "static/media/uga.d3ce3dae.jpg";